import { SignedIn, SignedOut, SignInButton } from "@clerk/clerk-react";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { Lock } from "lucide-react";
import { useTranslation } from "react-i18next";
import { ErrorPage } from "@/components/ErrorPage";

export const Route = createFileRoute("/_auth")({
	component: Auth,
	errorComponent: AuthErrorPage,
});

function Auth() {
	const { t } = useTranslation();

	return (
		<div>
			<SignedIn>
				<Outlet />
			</SignedIn>
			<SignedOut>
				<div className="min-h-screen bg-base-100 flex items-center justify-center p-4">
					<div className="w-full max-w-md mx-auto">
						<div className="bg-base-100 border border-base-300 rounded-xl shadow-lg p-8 text-center">
							<div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
								<Lock className="w-8 h-8 text-primary" />
							</div>
							<h1 className="text-2xl font-bold mb-2">{t("signInRequired")}</h1>
							<p className="text-base-content/70 mb-6">
								{t("signInRequiredDescription")}
							</p>
							<div className="flex flex-col gap-3">
								<SignInButton>
									<div className="btn btn-primary text-primary-content rounded-full px-6 transition-all duration-300 hover:shadow-lg hover:bg-primary-focus">
										{t("signIn")}
									</div>
								</SignInButton>
							</div>
						</div>
					</div>
				</div>
			</SignedOut>
		</div>
	);
}

function AuthErrorPage({ error }: { error: Error }) {
	const handleHome = () => {
		window.location.href = "/app";
	};

	const handleRetry = () => {
		window.location.reload();
	};

	return (
		<ErrorPage
			error={error}
			showBackButton={true}
			showHomeButton={true}
			showRetryButton={true}
			onHome={handleHome}
			onRetry={handleRetry}
		/>
	);
}
